import { render } from "./SelfAssessmentV2Text.vue?vue&type=template&id=acc5ad56&scoped=true"
import script from "./SelfAssessmentV2Text.vue?vue&type=script&lang=js"
export * from "./SelfAssessmentV2Text.vue?vue&type=script&lang=js"

import "./SelfAssessmentV2Text.vue?vue&type=style&index=0&id=acc5ad56&lang=sass&scoped=true"

import exportComponent from "../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acc5ad56"]])

export default __exports__